import getLtvFromOwnMargin from "./getLTVFromOwnMargin";

export default getLtvFromOwnMargin;
